export const STATUS_PENDING = 'PENDING_PAYMENT'
export const STATUS_PAID = 'PAID'
export const STATUS_NOT_PAID = 'NOT_PAID'
export const STATUS_ACTIVE = 'ACTIVE'

export const PAYMENT_ONBOARDING_FEE = 'ONBOARDING_FEE'
export const PAYMENT_MEMBERSHIP_FEE = 'MEMBERSHIP_FEE'
export const PAYMENT_PLACEMENT_FEE = 'PLACEMENT_FEE'
export const PAYMENT_WHIZZKID_FEE = 'WHIZZKID_FEE'
